import React from 'react';
import { Card, Row } from 'react-bootstrap';
import { Testo, TestoLungo, Tendina, Elenco, SolaLettura } from './campi';
import { lingue, sessi, limitiNascita } from './modificaAnagrafica';

/*
 * Tab dei dati anagrafici (IDS / Informazioni) in modifica, per player, maestro e junior.
 * Email di accesso e username non si cambiano da qui (sono le credenziali): l'email si vede in sola lettura.
 * Props: tipo ('player' | 'maestro' | 'junior'), modifica (useModificaAnagrafica), email (di accesso, facoltativa).
 */
const DatiAnagraficiModifica = ({ tipo, modifica, email }) => {
    const { f, imposta } = modifica;
    const senior = tipo !== 'junior';
    const nascita = limitiNascita(tipo);
    const campo = (chiave) => ({ id: chiave, valore: f[chiave], onChange: (v) => imposta(chiave, v) });

    return (
        <Card>
            <Card.Body className="sid-card-body--spaced">
                <h5 className="sid-form-section">Dati personali</h5>
                <Row className="g-4">
                    <Testo {...campo('givenName')} etichetta="Nome *" />
                    <Testo {...campo('familyName')} etichetta="Cognome *" />
                    <Testo
                        {...campo('birthdate')}
                        tipo="date"
                        etichetta={tipo === 'junior' ? 'Data di nascita (da 0 a 17 anni) *' : 'Data di nascita'}
                        min={nascita.min}
                        max={nascita.max}
                    />
                    <Tendina {...campo('gender')} etichetta="Sesso" opzioni={sessi} />
                    <Testo {...campo('taxCode')} etichetta="Codice fiscale" maxLength={16} />
                    <Testo {...campo('nationality')} etichetta="Nazionalità" />
                    <Testo {...campo('nation')} etichetta="Nazione" />
                    {senior && <Testo {...campo('profession')} etichetta="Professione" />}
                    {senior && <Testo {...campo('phoneNumber')} tipo="tel" etichetta="Telefono" />}
                    {email ? <SolaLettura etichetta="Email di accesso" valore={email} /> : null}
                    <Elenco id="spokenLocales" etichetta="Lingue parlate" opzioni={lingue} valori={f.spokenLocales} onChange={(v) => imposta('spokenLocales', v)} larghezza={12} />
                    <TestoLungo {...campo('description')} etichetta="Descrizione" />
                </Row>

                <h5 className="sid-form-section">Indirizzo</h5>
                <Row className="g-4">
                    <Testo {...campo('streetAddress')} etichetta="Via" />
                    <Testo {...campo('locality')} etichetta="Località" />
                    <Testo {...campo('province')} etichetta="Provincia" />
                    <Testo {...campo('postalCode')} etichetta="CAP" inputMode="numeric" />
                    <Testo {...campo('country')} etichetta="Paese" />
                </Row>

                {tipo === 'maestro' && (
                    <>
                        <h5 className="sid-form-section">Dati professionali</h5>
                        <Row className="g-4">
                            <Testo {...campo('vatNumber')} etichetta="Partita IVA" />
                            <Testo {...campo('sdi')} etichetta="Codice SDI" />
                            <Testo {...campo('professionalPhone')} tipo="tel" etichetta="Telefono professionale" />
                            <Testo {...campo('professionalEmail')} tipo="email" etichetta="Email professionale" />
                        </Row>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default DatiAnagraficiModifica;
